$(function() {

    var datas_state = null;
    var selected_day = null;

    let el = $('#facility-calendar')[0];
    var calendar = new FullCalendar.Calendar(el, {
        contentHeight: 'auto',
        showNonCurrentDates: false,
        fixedWeekCount: false,
        windowResizeDelay: 500,
        locale: 'ja',
        initialView: 'dayGridMonth',
        headerToolbar: {
            center: 'title',
            left: 'prev',
            right: 'next',
        },
        events: onChangeMonth,
        dateClick: onDateClicked,
        eventClick: onEventClicked,
        select: selectDate,
        unselect: unselectDate,

        unselectAuto: false,

        views: {
            dayGridMonth: {
                dayCellContent: function(e) {
                    e.dayNumberText = e.dayNumberText.replace('日', '');
                }
            }
        },
        titleFormat: function(date) {
            month = date.date.month;
            if ( month > 8 ) {
                largeMonth = `${date.date.year}. ${date.date.month + 1}`;
                return largeMonth;
            } else {
                smallMonth = `${date.date.year}. 0${date.date.month + 1}`;
                return smallMonth;
            }
        }
    });
    calendar.render();

    $('.c-btn-modal').on('click', function() {
        calendar.render();
    });

    /**
     *  月切り替え時
     */
    function onChangeMonth(info, successCallback, failureCallback) {
        const start = `${info.start.getFullYear()}-${info.start.getMonth()+1}-${info.start.getDate()}`;
        const end = `${info.end.getFullYear()}-${info.end.getMonth()+1}-${info.end.getDate()}`;
        let url = $('#facility-calendar-url').val();
        url = url.replace('rep_start', start).replace('rep_end', end);

        $.ajax({
            type: 'GET',
            url: url,
            dataType: 'json',

        }).done(function(datas) {
            datas_state = datas.data;   // 取得結果を保持

            successCallback(
                datas.data.map((data) => {
                    return {
                        title: data.vacancy.facility_schedule_status_mark,
                        start: data.day,
                        //color: data.vacancy.color,
                        //textColor: 'white',
                        className: '',
                    }
                })
            );

        }) .fail(function(error) {
            console.log('fail', error);
            failureCallback(error);
        });

    }

    /**
     *  日付選択時
     */
    function onDateClicked(info) {
        // console.log(info);
        const date = info.dateStr;
        info.view.calendar.select(date);
    }

    /**
     *  イベント選択時
     */
    function onEventClicked(info) {
        // console.log(info);
        const date = info.event.startStr;
        info.view.calendar.select(date);
    }

    /**
     * 日付選択処理
     */
    function selectDate(info) {
        const date = info.startStr;

        let target = datas_state.filter(function(item) {
            return item.day == date;
        });

        if (!target.length) {
            selected_day = null;
            $('#comment').empty();
            $('#bookings').empty();
            $('#select-date').attr('disabled', 'disabled');
            return;
        }

        selected_day = date;
        $('#comment').empty();
        $('#comment').append(window.commonjs.htmlspecialchars(target[0].vacancy.comment));
        $('#bookings').empty();
        $.each(target[0].bookings, function(i, v) {
            let body = '';
            body += '<hr />';
            body += `<p class="booking-info">${window.commonjs.htmlspecialchars(v.booking_label)}</p>`;
            body += `<p class="lesson-title">${window.commonjs.htmlspecialchars(v.lesson_name)}</p>`;
            body += `<p class="user-name">by ${window.commonjs.htmlspecialchars(v.user_name)}</p>`;

            $('#bookings').append(body);
        });
        $('#select-date').removeAttr('disabled');
    }

    function unselectDate(event, view) {
        selected_day = null;
        $('#comment').empty();
        $('#bookings').empty();
        $('#select-date').attr('disabled', 'disabled');
    }

});
